import { defineComponent as S, ref as k, useTemplateRef as u, createElementBlock as f, openBlock as p, mergeProps as s, unref as m, createVNode as i, withCtx as n, createElementVNode as g, createTextVNode as r, toDisplayString as a, Fragment as y, renderList as O, createBlock as w } from "vue";
import R from "../Menu/Menu.vue2.js";
import C from "../MenuToggle/MenuToggle.vue2.js";
import h from "../Menu/MenuContent.vue2.js";
import N from "../Menu/MenuItem.vue2.js";
import U from "../../helpers/FloatingUi.vue2.js";
import { defaultPerPageOptions as P } from "./common.js";
import { useOUIAProps as V } from "../../helpers/ouia.js";
const q = /* @__PURE__ */ S({
  name: "PfPaginationOptionsMenu",
  inheritAttrs: !1,
  __name: "PaginationOptionsMenu",
  props: {
    count: { default: 0 },
    firstIndex: { default: 0 },
    lastIndex: { default: 0 },
    itemsPerPageTitle: { default: "Items per page" },
    perPageSuffix: { default: "per page" },
    itemsTitle: {},
    optionsToggle: { default: "Items per page" },
    appendTo: {},
    ouiaId: {},
    ouiaSafe: { type: Boolean },
    lastFullPageShown: { type: Boolean },
    disabled: { type: Boolean },
    dropUp: { type: Boolean },
    page: { default: 0 },
    perPage: { default: P[0].value },
    perPageOptions: { default: () => [...P] },
    widgetId: { default: "pagination-options-menu" }
  },
  emits: ["update:perPage"],
  setup(c, { emit: v }) {
    const d = c, I = V({ id: d.ouiaId, safe: d.ouiaSafe }), $ = v, o = k(!1), T = u("elRef"), b = u("toggleRef");
    function B() {
      var e;
      o.value = !o.value, (e = b.value) == null || e.focus();
    }
    return (e, l) => (p(), f("div", s(m(I), { ref: "elRef" }), [
      i(C, {
        id: e.widgetId ? `${e.widgetId}-toggle` : void 0,
        ref: "toggleRef",
        expanded: o.value,
        "onUpdate:expanded": l[0] || (l[0] = (t) => o.value = t),
        disabled: e.disabled || !!(e.count && e.count <= 0),
        variant: "plainText",
        "aria-haspopup": "listbox"
      }, {
        default: n(() => [
          g("b", null, a(e.firstIndex) + " - " + a(e.lastIndex), 1),
          l[1] || (l[1] = r(" of ")),
          g("b", null, a(e.count), 1),
          r(" " + a(e.itemsTitle), 1)
        ]),
        _: 1
      }, 8, ["id", "expanded", "disabled"]),
      i(U, {
        hidden: !o.value,
        "teleport-to": e.appendTo,
        reference: m(T),
        flip: ""
      }, {
        default: n(() => [
          i(R, s(e.$attrs, { onSelect: B }), {
            default: n(() => [
              i(h, null, {
                default: n(() => [
                  (p(!0), f(y, null, O(e.perPageOptions, (t) => (p(), w(N, {
                    key: t.title,
                    "data-action": `per-page-${t.value}`,
                    selected: e.perPage === t.value,
                    component: "button",
                    onClick: (_) => $("update:perPage", t.value)
                  }, {
                    default: n(() => [
                      r(a(t.title) + " " + a(` ${e.perPageSuffix}`), 1)
                    ]),
                    _: 2
                  }, 1032, ["data-action", "selected", "onClick"]))), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }, 8, ["hidden", "teleport-to", "reference"])
    ], 16));
  }
});
export {
  q as default
};
